import styled from "styled-components";
import Table from "../DataTable";
import ListWithPagination from "../ListsWithPagination";

interface Props {
  data: {
    outlet: string;
    customer: string;
    date_time: string;
    amount: number;
    contact: string;
    reason: string;
    comment: string;
  }[];

  isTableDataLoading: boolean;
}

const DisputeHistoryTable = ({ data, isTableDataLoading }: Props) => {
  const getContent = (value: any, width: string | number) => (
    <div
      style={{
        width: `${width}`,
        whiteSpace: "initial",
      }}
    >
      {value}
    </div>
  );

  const columns = [
    {
      key: "outlet",
      label: "Outlet",
      content: (data: any) => getContent(data.outlet, "100px"),
    },
    {
      path: "customer",
      label: "Customer",
    },
    {
      key: "date_time",
      label: "Date & Time",
      content: (data: any) => getContent(data.date_time, "50px"),
    },
    {
      path: "amount",
      label: "Amount",
    },
    {
      path: "contact",
      label: "Contact",
    },
    {
      key: "reason",
      label: "Reason",
      content: (data: any) => getContent(data.reason, "100px"),
    },
    {
      key: "comment",
      label: "Comment",
      content: (data: any) => getContent(data.comment, "150px"),
    },
    {
      path: "status",
      label: "Status",
    },
  ];

  return (
    <>
      <TableWrapper>
        <Table
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={""}
          hidePagination={true}
          currentPage={0}
          totalData={0}
          rowsPerPage={0}
          onPageChange={function (page: number): void {
            throw new Error("Function not implemented.");
          }}
        />
      </ListWrapper>
    </>
  );
};
const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    padding-top: 4.5rem;
    display: none;
  }
`;
const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

export default DisputeHistoryTable;
